import { Views } from '@neos/app'
import { OpenModeType, PopupPosition } from '@neos/shared'

export const views: Views = {
  default: [
    {
      name: 'ConveyerMessageUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/ConveyerMessageUI/ConveyerMessageUI.vue'),
    },
    {
      name: 'CultureListUI',
      openMode: OpenModeType.popupAutoSize,
      popupPosition: PopupPosition.center,
      component: () => import('./views/CultureListUI/CultureListUI.vue'),
    },
    {
      name: 'KnownIanaTimeZoneUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/KnownIanaTimeZoneUI/KnownIanaTimeZoneUI.vue'),
    },
    {
      name: 'MailMergeMessageUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/MailMergeMessageUI/MailMergeMessageUI.vue'),
    },
    {
      name: 'NeosBaseUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/NeosBaseUI/NeosBaseUI.vue'),
    },
    {
      name: 'NotifierMessageUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/NotifierMessageUI/NotifierMessageUI.vue'),
    },
  ],
}
